import type { ComponentProps } from 'react';

import { Button } from '@/components/ui/button';

import { INTENT_VARIANT, type ActionIntent } from '../config/intent-variant';

type ActionButtonProps = Omit<ComponentProps<typeof Button>, 'variant'> & {
  intent: ActionIntent;
};

export function ActionButton({ intent, ...props }: ActionButtonProps) {
  return <Button variant={INTENT_VARIANT[intent]} data-intent={intent} {...props} />;
}
